export enum SupportContextKey {
  Default = 'default',
  Login = 'login',
  DailyLog = 'daily-log',
  DailyLogSummary = 'daily-log-summary',
  AddToDailyLog = 'add-to-daily-log',
  EditOperation = 'edit-operation',
  LegLoads = 'leg-loads',
  WeatherLog = 'weather-log',
  DprSections = 'dpr-sections',
  JackingActivities = 'jacking-activities',
  VoyageLog = 'voyage-log',
  MorningMinutes = 'morning-minutes',
  EditProject = 'edit-project',
  ChangeTimeZone = 'change-time-zone',
  Cycles = 'cycles',
  CompleteDay = 'complete-day',
  ImplementerMode = 'implementer-mode',
  ChangeHistory = 'change-history'
}

export class SupportContext {
  key: SupportContextKey = SupportContextKey.Default;
  label: string = 'General';
  pageName?: string;
  componentName?: string;
  details?: {[key: string]: string};
  additionalSuggestedContextKeys?: SupportContextKey[];
}

export class SupportVideo {
  id: number;
  title: string;
  fileName: string;
  url: string;
  chapters?: SupportVideoChapter[];
}

export class SupportVideoChapter {
  title: string;
  startTime: number;
  endTime?: number;
}

export class SupportTrainingMenuItem {
  id: string;
  title: string;
  video: SupportVideo;
  startTime: number;
  endTime?: number;
  thumbnailUrl: string;
}

export class ServiceDeskTicketRequest {
  name: string;
  email: string;
  ccName: string;
  ccEmail: string;
  reviewedTrainingVideos: boolean = false;
  issueDescription: string;
  contextLabel: string;
  contextKey: string;
  contextDetails?: {[key: string]: string};
  attachments: File[] = [];
}



// WEBPACK FOOTER //
// ./src/models/support/support.models.ts